import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ISalesItemResetCategoryModel extends IModel {
  salesItemResetCategoryId: number;
  name: string;
}

export class SalesItemResetCategoryModel
  extends Model
  implements ModelRecord<ISalesItemResetCategoryModel>
{
  salesItemResetCategoryId: number;
  name: string;
  constructor(params?: Partial<ISalesItemResetCategoryModel>) {
    super(params);
    this.salesItemResetCategoryId = defaultTo(
      params?.salesItemResetCategoryId,
      0,
    );
    this.name = defaultTo(params?.name, '');
  }
}
